import { render, staticRenderFns } from "./SampleFooter.vue?vue&type=template&id=5deabfb9&scoped=true"
import script from "./SampleFooter.vue?vue&type=script&lang=js"
export * from "./SampleFooter.vue?vue&type=script&lang=js"
import style0 from "./SampleFooter.vue?vue&type=style&index=0&id=5deabfb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deabfb9",
  null
  
)

export default component.exports